/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ItemBatchDetailTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const itemBatchDetailResetModelTimestamp = state => ({
  ...state,
  modelTimestamp: Date.now()
});

export const itemBatchDetailSetResId = (state, { resId }) => ({
  ...state,
  modelTimestamp: Date.now(),
  resId
});

export const itemBatchDetailShowModelLoading = (state, { boolean }) => ({
  ...state,
  modelIsLoading: boolean
});

export const itemBatchDetailShowModelSuccess = (state, { model }) => ({
  ...state,
  model
});

export const itemBatchDetailUpdateModelSuccess = (state, { model }) => ({
  ...state,
  model
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ItemBatchDetailTypes.ITEM_BATCH_DETAIL_RESET_MODEL_TIMESTAMP]: itemBatchDetailResetModelTimestamp,
  [ItemBatchDetailTypes.ITEM_BATCH_DETAIL_SET_RES_ID]: itemBatchDetailSetResId,
  [ItemBatchDetailTypes.ITEM_BATCH_DETAIL_SHOW_MODEL_LOADING]: itemBatchDetailShowModelLoading,
  [ItemBatchDetailTypes.ITEM_BATCH_DETAIL_SHOW_MODEL_SUCCESS]: itemBatchDetailShowModelSuccess,
  [ItemBatchDetailTypes.ITEM_BATCH_DETAIL_UPDATE_MODEL_SUCCESS]: itemBatchDetailUpdateModelSuccess
});
